module.exports = __webpack_public_path__ + "static/media/search.49897241.svg";